// Docs: https://stripe.com/docs/stripe-js/react#elements-provider

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY as string)

export const StripeProvider: React.FC = ({ children }) => (
  <Elements
    stripe={stripePromise}
    options={{
      fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=Poppins' }],
    }}
  >
    {children}
  </Elements>
)
